var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M20.8554 19V10H21.7483C22.0795 10 22.3892 9.8361 22.5753 9.56224C22.8858 9.1055 22.7673 8.48353 22.3105 8.17304L13.4176 2.12759C13.0783 1.89692 12.6325 1.89692 12.2932 2.12759L3.4002 8.17304C3.12634 8.35921 2.9624 8.66889 2.9624 9.00004C2.9624 9.55233 3.41012 10 3.9624 10H4.8554V19C4.8554 20.1046 5.75083 21 6.8554 21H18.8554C19.96 21 20.8554 20.1046 20.8554 19ZM7.19237 9.72901C6.91417 9.91448 6.74707 10.2267 6.74707 10.5611V18.0259C6.74707 18.5782 7.19479 19.0259 7.74707 19.0259H17.7471C18.2994 19.0259 18.7471 18.5782 18.7471 18.0259V10.5611C18.7471 10.2267 18.58 9.91448 18.3018 9.72901L13.3018 6.39568C12.9659 6.17175 12.5283 6.17175 12.1924 6.39568L7.19237 9.72901Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
